// src/admin/screens/collections/ContactHistory.tsx
// Vertical timeline of every collection_contacts row for this loan,
// newest first. Promises to pay surface the amount + date so the agent
// can verify whether the borrower kept them; free-form notes preserve
// whitespace so agents can paste multi-line call summaries.
import Card from '@admin/components/Card';
import Money from '@admin/components/Money';
import StatusChip from '@admin/components/StatusChip';
import { formatCatDateTime } from '@admin/utils/dates';
import { CHANNEL_LABEL, OUTCOME_LABEL, OUTCOME_TONE } from '@admin/utils/collections';
import type { CollectionsContact } from '@admin/hooks/useCollectionsCase';

export default function ContactHistory({ contacts }: { contacts: CollectionsContact[] }) {
  if (contacts.length === 0) {
    return (
      <Card title="Contact history">
        <p style={{ color: 'var(--c-text-muted)', margin: 0 }}>No contact logged yet.</p>
      </Card>
    );
  }
  return (
    <Card title={`Contact history (${contacts.length})`}>
      <ol style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {contacts.map((c) => (
          <li
            key={c.id}
            style={{ padding: '10px 0', borderTop: '1px solid var(--c-border-light)' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 4 }}>
              <StatusChip label={OUTCOME_LABEL[c.outcome]} tone={OUTCOME_TONE[c.outcome]} />
              <span style={{ color: 'var(--c-text-muted)', fontSize: 12 }}>
                {CHANNEL_LABEL[c.channel]} · {formatCatDateTime(c.contacted_at)}
              </span>
            </div>
            {c.ptp_amount_ngwee !== null && c.ptp_date && (
              <p className="small" style={{ margin: '2px 0' }}>
                Promised <strong><Money amount={c.ptp_amount_ngwee} /></strong> by <strong>{c.ptp_date}</strong>
              </p>
            )}
            {c.notes && (
              <p className="small" style={{ margin: '2px 0', whiteSpace: 'pre-wrap' }}>
                {c.notes}
              </p>
            )}
            <p className="small" style={{ color: 'var(--c-text-muted)', marginTop: 4 }}>
              by {c.agent_name ?? 'Unknown agent'}
            </p>
          </li>
        ))}
      </ol>
    </Card>
  );
}
